import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo, MensajeCapcha } from '../../mensajes2';

import { Dimmer } from '../../spinner';

import {
    ValidCaptcha, validaSoloNumero, formatMoneda, validaMonto, formatoMonto,
    seleccionarCampo, validaNumeroTelefono, validaEmail
} from '../../../util/varios';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import axios from 'axios';
import useTableFijo from '../../useTableFijo';
import Tablahtpp from './tablaHistoryPP';
import TablaDeudappd from './tablaDeudasPPD';


const headCells = [
    { id: 'idactividad', label: 'CODIGO', width: '10px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'descripcion', label: 'DESCRIPCION DE PUBLICIDAD COMERCIAL', width: '250px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'alicuota', label: 'ALICUOTA', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'minimo', label: 'AREA/UNID', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'alicuota', label: 'MONTO A PAGAR', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    { id: 'alicuota', label: 'CANCELAR', width: '100px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
]

export const ConsultarDeuda = (props) => {

    /*  variables de estados */

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [factorCambio,setFactorCambio] = useState(0)

    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [visible, setVisible] = useState(false);
    const [activate, setActivate] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habilitadoNR, setHabilitadoNR] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [anio, setAnio] = useState([]);
    const [visibleF, setVisibleF] = useState('hidden');
    const [cargar, setCargar] = useState(false);
    const [status, setStatus] = useState();

    const [values, setValues] = useState({
        idcomercio: '',
        ritm: '',
        nombre: '',
        direccion: '',
        motivopublicidad: '',
        telefono: '',
        status: '',
        statuspublicidad: ''
    });

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let heightTabla = 320;

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, heightTabla);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idactividad.includes(target.value)
                            || x.codigoactividad.toLowerCase().includes(target.value.toLowerCase())
                            || x.codigociu.toLowerCase().includes(target.value.toLowerCase())
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.alicuota.replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value)
                            || formatMoneda(x.minimo.replace(',', '').replace('.', ','), ',', '.', 2).includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const handleCloseNoo = () => {
        setMostrar3(false);
    };


    const handleCloseSi = () => {
        if (msg === "Esta Segudo de Cambiar el Estatus a Activo?") {

        } else {
            setMostrar4(true);
        }
        setMostrar1(false);

    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };

    const handleCloseMensa = (e) => {
        e.preventDefault();
        setMostrar(false);
        if (msg == 'Motivo Anulado Correctamente' || msg == 'Error al Registrar el Motivo') {

            props.onHideRenderizar(props.comercio.idcomercio);


        }

    }


    const cancelar = (e) => {
        e.preventDefault();
        setHabilitadoNR(false);
        blanquear();
        props.onHideCancela();

    }

    useEffect(() => {

        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        var nanio = []
        var aini = parseInt(obj.anioactu) - 23;
        var afin = parseInt(obj.anioactu);
        for (let i = 1; i <= afin - aini; i++) {
            nanio.push({ anio: aini + i });

        }
        setAnio(nanio);
        if (props.operacion) {
            setOperacion(props.operacion);
        }

    }, []);

    const blanquear = () => {
        setMostrar(false);
        setMostrar3(false);
        setMostrar4(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setVisibleF('hidden');
        setValues({
            idcomercio: '',
            ritm: '',
            nombre: '',
            direccion: '',
            motivopublicidad: '',
            telefono: '',
            status: '',
            statuspublicidad: ''
        });
    }


    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setFactorCambio(props.factorCambio)
                setVisible(false);
                setDeshabilitado(props.deshabilitado);
                setOperacion(props.operacion);
                setCargar(true);
                if (props.operacion !== 1) {
                    setValues(props.comercio);
                    setStatus(props.comercio ? props.comercio.statuspublicidad == "1" ? "ACTIVO" : "INACTIVO" : "");
                }

            }}

        >
            <Modal.Header className='azulGradiant' style={{ height: '40px' }}>
                <div style={{ color: "#fff", fontSize: 20 }}>{operacion === 1 ? 'Agregar Propaganda y Publicidad.' : operacion === 2 ? 'Propaganda y Publicidad.' : operacion === 3 ? 'Eliminar Propaganda y Publicidad.' : 'Consultar Deuda de Propaganda y Publicidad.'}</div>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#ffffff", color: "" }}>
                <Mensaje mensaje={mensaje}
                    onHide={() => { setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' }) }

                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>

                    <div className='row rounded mx-auto'>
                        <div className='container col-md-12 mx-auto' style={{ backgroundColor: "", color: "" }}>
                            <div className='mx-auto w-100'>
                                <table className="table table-sm w-100 table-bordered" style={{ fontSize: '12px' }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="fw-bold">Código:  &nbsp; </span>
                                                <label for="colFormLabelSm" className="form-label">{values && values.idcomercio}</label>
                                            </td>
                                            <td >
                                                <span className="fw-bold"> Nº de RITM:  &nbsp; </span>
                                                <label for="colFormLabelSm" className="form-label">{values && values.ritm}</label>
                                            </td>
                                            <td>
                                                <span className="fw-bold"> ESTATUS:  &nbsp; </span>
                                                <label for="colFormLabelSm" className="form-label">{status}</label>
                                            </td>
                                            <td className='fw-bold'>
                                              {'Valor Euro €: '+formatMoneda(factorCambio.toString().replace(',', '').replace('.', ','), ',', '.', 2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                   
                                </table>
                                <table className="table table-sm w-100 table-bordered" style={{ fontSize: '12px' }}>
                                 
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="fw-bold"> DENOMINACIÓN COMERCIAL:&nbsp; </span>
                                                <label for="colFormLabelSm" className="form-label">{values && values.nombre ? values.nombre !== null ? values.nombre.trim() : '' : ''}</label>
                                            </td>
                                            <td>
                                                <span className="fw-bold"> DIRECCIÓN:&nbsp; </span>
                                                <label for="colFormLabelSm" className="form-label">{values && values.direccion ? values.direccion !== null ? values.direccion.trim() : '' : ''}</label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <ul className="nav " id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a className=" rounded nav-link active bg-blue-100 text-light" disabled={operacion === 1 || operacion === 3 ? true : deshabilitado} id="deuda-tab" data-bs-toggle="tab" data-bs-target="#deuda" type="button" role="tab" aria-controls="deuda" aria-selected="false" >Deudas del Contribuyente</a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a className=" rounded nav-link bg-blue-200 text-light" disabled={operacion === 1 || operacion === 3 ? true : deshabilitado} id="historico-tab" data-bs-toggle="tab" data-bs-target="#historico" type="button" role="tab" aria-controls="historico" aria-selected="false" >Historico de Pagos</a>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="deuda" role="tabpanel" aria-labelledby="deuda-tab">
                            <TablaDeudappd
                                tabdeuda={props.deuda}
                                total={props.total}
                                recargo={props.recargo}
                                valorpetro={props.valorut}
                                idcomercio={props.comercio && props.comercio.idcomercio}
                                cargar={cargar}
                            />
                        </div>
                        <div className="tab-pane fade" id="historico" role="tabpanel" aria-labelledby="historico-tab">
                            <Tablahtpp
                                tabhistoy={props.history}
                                total={props.total}
                                idcomercio={props.comercio && props.comercio.idcomercio}
                                cargar={cargar}
                            />
                        </div>
                    </div>
                </div>


            </Modal.Body >
            <Modal.Footer style={{ backgroundColor: "" }}>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal >
    );
}